// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_container__CnP\\+G {
    padding: 1rem;
    max-width: 1200px;
    margin: 0 auto;
}

.Pagination_gridContainer__IoLDR {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.Pagination_gridContainerMobile__J5xxh {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.Pagination_card__NwM4Z {
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background-color: white;
    transition: box-shadow 0.3s ease;
}

.Pagination_card__NwM4Z:hover {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.Pagination_image__qVk9j {
    width: 100%;
    height: auto;
    border-radius: 0.5rem;
}

.Pagination_paginationWrapper__Nagje {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
}

.Pagination_paginationButton__jHumq {
    padding: 0.5rem 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    font-weight: 600;
    color: #4b4b4b;
    background-color: #fff;
}

.Pagination_paginationButton__jHumq:hover {
    background-color: #f0f0f0;
    transform: scale(1.05); /* Adds a subtle zoom effect on hover */
}

.Pagination_paginationButton__jHumq:focus {
    outline: 2px solid #3b82f6; /* Highlighted focus for accessibility */
    outline-offset: 2px;
}

.Pagination_paginationButtonDisabled__5zOlO {
    opacity: 0.5;
    cursor: not-allowed;
}

.Pagination_pageNumberButton__7lqf6 {
    padding: 0.5rem 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    font-weight: 600;
    color: #4b4b4b;
    background-color: #fff;
    margin-right: 10px;
}

.Pagination_pageNumberButton__7lqf6:hover {
    background-color: #f0f0f0;
    transform: scale(1.05); /* Adds a subtle zoom effect on hover */
}

.Pagination_pageNumberButtonActive__IDnHU {
    background-color: #3b82f6;
    color: white;
    font-weight: 700; /* Makes active page button stand out more */
}

.Pagination_pageInfo__rB2ae {
    text-align: center;
    margin-top: 1rem;
    color: #4b4b4b;
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/demo/Pagination.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC;IACxC,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,2DAA2D;IAC3D,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB,EAAE,uCAAuC;AACnE;;AAEA;IACI,0BAA0B,EAAE,wCAAwC;IACpE,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,2DAA2D;IAC3D,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB,EAAE,uCAAuC;AACnE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB,EAAE,4CAA4C;AAClE;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".container {\n    padding: 1rem;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.gridContainer {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.gridContainerMobile {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.card {\n    padding: 1rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 0.5rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    background-color: white;\n    transition: box-shadow 0.3s ease;\n}\n\n.card:hover {\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n}\n\n.image {\n    width: 100%;\n    height: auto;\n    border-radius: 0.5rem;\n}\n\n.paginationWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.paginationButton {\n    padding: 0.5rem 1rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    font-weight: 600;\n    color: #4b4b4b;\n    background-color: #fff;\n}\n\n.paginationButton:hover {\n    background-color: #f0f0f0;\n    transform: scale(1.05); /* Adds a subtle zoom effect on hover */\n}\n\n.paginationButton:focus {\n    outline: 2px solid #3b82f6; /* Highlighted focus for accessibility */\n    outline-offset: 2px;\n}\n\n.paginationButtonDisabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.pageNumberButton {\n    padding: 0.5rem 1rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    font-weight: 600;\n    color: #4b4b4b;\n    background-color: #fff;\n    margin-right: 10px;\n}\n\n.pageNumberButton:hover {\n    background-color: #f0f0f0;\n    transform: scale(1.05); /* Adds a subtle zoom effect on hover */\n}\n\n.pageNumberButtonActive {\n    background-color: #3b82f6;\n    color: white;\n    font-weight: 700; /* Makes active page button stand out more */\n}\n\n.pageInfo {\n    text-align: center;\n    margin-top: 1rem;\n    color: #4b4b4b;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Pagination_container__CnP+G`,
	"gridContainer": `Pagination_gridContainer__IoLDR`,
	"gridContainerMobile": `Pagination_gridContainerMobile__J5xxh`,
	"card": `Pagination_card__NwM4Z`,
	"image": `Pagination_image__qVk9j`,
	"paginationWrapper": `Pagination_paginationWrapper__Nagje`,
	"paginationButton": `Pagination_paginationButton__jHumq`,
	"paginationButtonDisabled": `Pagination_paginationButtonDisabled__5zOlO`,
	"pageNumberButton": `Pagination_pageNumberButton__7lqf6`,
	"pageNumberButtonActive": `Pagination_pageNumberButtonActive__IDnHU`,
	"pageInfo": `Pagination_pageInfo__rB2ae`
};
export default ___CSS_LOADER_EXPORT___;
